import { AfterViewInit, Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { AuthService } from 'src/app/auth.service';
import { SettingService } from '../services/setting.service';
import { BaseService } from '../services/base.service';
import { BaseComponent } from 'src/app/system-common/base/base.component';

@Component({
  selector: 'sym-disclaimer',
  templateUrl: './disclaimer.component.html',
  styleUrls: ['./disclaimer.component.scss'],
})
export class DisclaimerComponent extends BaseComponent<BaseService> implements AfterViewInit {
  @Input() displayPopupOnly: boolean;
  @Output() acceptDisclaimerCLicked = new EventEmitter<void>();
  @Output() disagreeDisclaimerCLicked = new EventEmitter<void>();

  constructor(
    public settingService: SettingService,
    public authService: AuthService,
    public service: BaseService
  ) {
    super(null);
    this.displayPopupOnly = false;
  }
  ngAfterViewInit() {
    this.setFocus('disagreeClick');
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['displayPopupOnly'] && changes['displayPopupOnly'].currentValue) {
      this.openPopup('disclaimerPopup');
    }
  }

  acceptDisclaimer($event: any) {
    this.authService.setDisclaimerInSession();
    this.acceptDisclaimerCLicked.emit();
  }
  disagreeDisclaimer($event: any) {
    this.authService.logoutUser();
    this.disagreeDisclaimerCLicked.emit();
  }
}
